import React, { useState, ChangeEvent, KeyboardEvent } from "react";
import "./CSS/SecondaryListingsAllSearchBar.css";

type Props = {
  onSearch: (query: string) => void;
};

function SecondaryListingsAllSearchBar({ onSearch }: Props) {
  // const searchTextFromStore = useAppSelector((state) => state.search_text);

  // const [searchQuery, setSearchQuery] = useState(searchTextFromStore);
  const [searchQuery, setSearchQuery] = useState("");

  const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      console.log(searchQuery);
      onSearch(searchQuery);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length == 0) onSearch(e.target.value);
    setSearchQuery(e.target.value);
  };

  return (
    <div className="all-secondary-listings-search-bar">
      <input
        type="text"
        placeholder="Search secondary_sku, master_sku, inventory_sku, pack_combo_sku..."
        value={searchQuery}
        onChange={handleInputChange}
        onKeyPress={handleKeyPress}
      />
    </div>
  );
}

export default SecondaryListingsAllSearchBar;
